var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIconBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1869 16.8536C10.9916 17.0488 10.675 17.0488 10.4798 16.8536L6.47978 12.8536C6.28452 12.6583 6.28452 12.3417 6.47978 12.1464L10.4798 8.14645C10.675 7.95118 10.9916 7.95118 11.1869 8.14645C11.3821 8.34171 11.3821 8.65829 11.1869 8.85355L8.04044 12L17.5 12C17.7761 12 18 12.2239 18 12.5C18 12.7761 17.7761 13 17.5 13L8.04044 13L11.1869 16.1464C11.3821 16.3417 11.3821 16.6583 11.1869 16.8536Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.333333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconBtn);
export default __webpack_public_path__ + "static/media/back_Icon_btn.18c2228770ad9963531508f6da53edf5.svg";
export { ForwardRef as ReactComponent };